module.exports = __webpack_public_path__ + "static/media/sur.1419862c.mp3";